import type { AccountForChildEligibilityDetails } from '@generated-types';
import { createContext } from 'react';

export interface AccountApplicationActionsType {
    setSelectedChildEligibility: (childEligibility: AccountForChildEligibilityDetails | null) => void;
    setApplicantParentEmail: (email: string | null) => void;
    setNotifyApproverParentOnPhoneNumber: (phoneNumber: string | null) => void;
    setApplicantParentHasGivenConsent: (consent: boolean) => void;
}

const initialAccountApplicationActions = {
    setSelectedChildEligibility: () => {},
    setApplicantParentEmail: () => {},
    setNotifyApproverParentOnPhoneNumber: () => {},
    setApplicantParentHasGivenConsent: () => {},
};

export const AccountApplicationActions = createContext<AccountApplicationActionsType>(initialAccountApplicationActions);
